import { TextComponent } from 'baseComponents/TextComponent';
import './AndroidPushPreview.scss';
import pjLogo from 'assets/images/pushPjlogo.svg';
import { truncateText } from 'utils/text';

export type AndroidPushPreviewProps = {
  title: string;
  body: string;
  time: string;
};

export const AndroidPushPreview = ({
  title,
  body,
  time,
}: AndroidPushPreviewProps) => (
  <div className='android-push-preview'>
    <TextComponent text='Android Preview' size='middle' weight='extra-bold' />
    <div className='android-push-preview__wrapper push-preview__body'>
      <div className='android-push-preview__content'>
        <div className='android-push-preview__image-wrapper'>
          <img
            src={pjLogo}
            alt='app icon'
            className='android-push-preview__icon'
          />
        </div>
        <div className='android-push-preview__body '>
          <div className='android-push-preview__header'>
            <TextComponent text={title} weight='extra-bold' size='small' />
            <span>⋅</span>
            <TextComponent
              text={time}
              weight='extra-light'
              size='extra-small'
              opacity
              className='android-push-preview__time'
            />
          </div>
          <TextComponent
            text={truncateText(body, 49)}
            weight='extra-light'
            size='small'
          />
        </div>
      </div>
    </div>
  </div>
);
